import { LoginService } from "src/app/auth/login.service";
import { ColorService } from "src/app/Services/color.service";
import { MediaService } from "src/app/Services/media.service";
import { OrganizationsService } from "src/app/Services/organizations.service";
import { ValetService } from "src/app/Services/valet.service";
import { Deviceicons } from "src/app/util/deviceicons";
import { environment } from "src/environments/environment";

/** HTML-encode dynamic fragments before embedding them in structural column markup (FP-1259). */
export function encodeHtml(value: unknown): string {
    if (value == null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export class Datalistviewcolumn {
    public Header: string = "";
    public Property: string = "";
    public MediaId: string = "";
    public Width: string = "";
    public MaxLength: number = Number.MAX_VALUE;
    public EnableFilter: boolean = false;
    public FilterColumn: string = "";
    public FilterValue: string = "Descending";
    public IsIcon: boolean = false;
    /** When true, Render() returns structural HTML for [innerHTML] + bypass after encoding dynamic fragments.
     *  When false (default), Render() is plain text and must be bound with {{ }} interpolation. */
    public RendersHtml: boolean = false;

    constructor(header?: string, property?: string, maxLength?: number) {
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (maxLength != null)
            this.MaxLength = maxLength;
    }

    public Render(item: any): string {
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        if (this.MaxLength != Number.MAX_VALUE) {
            return item[this.Property].substring(0, this.MaxLength) + "...";

        } else {
            return item[this.Property];
        }
    }
}

export class ValetTagListColumn extends Datalistviewcolumn {
    public HasModal : boolean = false;
    public ModalName : string | null = null;
    public valetService !: ValetService;

    constructor(header?: string, property?: string, valetService ?: ValetService) {
        super(header);
        this.RendersHtml = true;
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (valetService != null){
            this.valetService = valetService;
        }
    }

    public override Render(item: any): string {
        var str = '';
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        var string = '';

        var addons = item[this.Property];
        addons.forEach((addon : any) => {
            if(addon.Status != "Rejected" && addon.Status != "Cancelled"){
                const label = encodeHtml(this.valetService.valetSessionDescription(addon.ValetAddonId, addon.ValetAddonOptionId) + " - " + addon.Status);
                string = string + '<div class="tag">' + label + '</div><br>'
            }
        });

        return string;
    }
}


export class CustomTextViewColumn extends Datalistviewcolumn {

    public customText: string | undefined;
    public ShowProperty: string | undefined;
    public excludeZeroValues : boolean = false;

    constructor(header?: string, property?: string, customText?: string, ShowProperty?: string, excludeZeroValues : boolean = false) {
        super(header);
        this.RendersHtml = true;
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (customText != null)
            this.customText = customText;
        if (ShowProperty != null)
            this.ShowProperty = ShowProperty;
        if (excludeZeroValues != null)
            this.excludeZeroValues = excludeZeroValues;
    }

    public override Render(item: any): string {
        var string = ""
        if(this.ShowProperty == undefined || item[this.ShowProperty]){
            //show the item

            if(this.excludeZeroValues && (item[this.Property] == null || item[this.Property] == 0)){
                return string;
            }

            var string = "<p>" + encodeHtml(this.customText?.replace("{0}", item[this.Property])) + "</p>";
        }
        return string;
    }
}

export class ClassedViewColumn extends Datalistviewcolumn {
    public HasModal : boolean = false;
    public ModalName : string | null = null;

    constructor(header?: string, property?: string, maxLength?: number, HasModal : boolean = false, ModalName: string | null = null) {
        super(header);
        this.RendersHtml = true;
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (maxLength != null)
            this.MaxLength = maxLength;
        if (HasModal != null)
            this.HasModal = HasModal;
        if (ModalName != null)
            this.ModalName = ModalName;
    }

    public OpenModal(item: any): void {
        console.log('Modal opened!');
    }

    public override Render(item: any): string {
        var str = '';
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        if (this.MaxLength != Number.MAX_VALUE) {
            str = item[this.Property].substring(0, this.MaxLength) + "...";

        } else {
            str = item[this.Property];
        }

        var itemClass = encodeHtml(String(str).split(" ").join("-"));
        var safe = encodeHtml(str);
        // Let the button size to its content; the table column will naturally size to the longest value.
        // Keep it non-interactive and prevent wrapping for a tidy "pill" look.
        return '<button class="button ' + itemClass + '" style="height:2em; padding:0 .75em; text-align:center; white-space:nowrap; pointer-events:none;"><p style="font-weight: bold; margin:0;">' + safe + "</p></button>";
    }
}

export class StateViewColumn extends Datalistviewcolumn {
    constructor(header?: string, property?: string) {
        super(header);
        this.RendersHtml = true;
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
    }

    public override Render(item: any): string {
        var str = '';
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        var state = item[this.Property];

        var severity = (state.Severity === 2 ? "High" : (state.Severity === 1 ? "Medium" : "Low"));
        return '<p style="text-align:end; margin-right:2em; width:6em; font-weight:600; color:#' + encodeHtml(state.ForegroundColor) + '" class="Text Flash ' + severity +' ">' + encodeHtml(state.DisplayName) + '<i class="Icon fa fa-' + encodeHtml(state.IconName) + '" style="font-size: x-large; margin-top: 0px !important; position:absolute;"></i><p>';
    }
}


export class SelectedViewColumn extends Datalistviewcolumn {
    public SelectedItems: any[] = [];
    constructor(header?: string, SelectedItems? : any[]) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (SelectedItems != null)
            this.SelectedItems = SelectedItems;
    }

    public override Render(item: any): string {
        let result = this.SelectedItems.filter((x: any) => x.Name == item.Name).length > 0 ? true : false;
        return(result == true ? '<p style="color: green;"><b>&#x2713;</b></p>' : '<p style="color: red;"><b>&#x2715;</b></p>' );

    }
}

export class DateRangeViewColumn extends Datalistviewcolumn {
    public StartDateProperty: string="";
    public EndDateProperty: string="";
    constructor(header?: string, StartDateProperty?: string, EndDateProperty?: string) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (StartDateProperty != null)
            this.StartDateProperty = StartDateProperty;
        if (EndDateProperty != null)
            this.EndDateProperty = EndDateProperty;
    }

    public override Render(item: any): string {
        let start = item[this.StartDateProperty];
        let end = item[this.EndDateProperty];

        let startExists = start != null && start != "" && start != undefined;
        let endExists = end != null && end != "" && end != undefined;

        if(startExists && endExists) {
            return '<p>' + encodeHtml(item[this.StartDateProperty]) + ' <b>&#x2192</b> ' + encodeHtml(item[this.EndDateProperty]) +'</p>';
        }
        else if (startExists) {
            return '<p> From ' + encodeHtml(start) + '</p>';
        }
        else if (endExists) {
            return '<p> Until ' + encodeHtml(end) + '</p>'
        }
        else {
            return '<p> Unlimited </p>';
        } 
    }
}


export class StarRatingViewColumn extends Datalistviewcolumn {
    public MaxStars: number = 5;

    constructor(header?: string, property?: string, maxStars: number = 5) {
        super(header);
        //the star markup below must be injected as HTML, not shown as escaped text
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (maxStars != null)
            this.MaxStars = maxStars;
    }

    public override Render(item: any): string {
        let raw = item[this.Property];
        if (raw == null || raw === '') {
            return '';
        }

        let rating = Math.round(Number(raw));
        if (isNaN(rating) || rating < 0) {
            return '';
        }
        if (rating > this.MaxStars) {
            rating = this.MaxStars;
        }

        let stars = '<span style="white-space:nowrap; color:#f5a623;" role="img" aria-label="' + rating + ' out of ' + this.MaxStars + ' stars">';
        for (let i = 1; i <= this.MaxStars; i++) {
            let iconClass = i <= rating ? 'fa fa-star' : 'fa fa-star-o';
            stars += '<i class="' + iconClass + '" style="margin-right:2px;" aria-hidden="true"></i>';
        }
        stars += '</span>';
        return stars;
    }
}

export class BooleanCheckOrCrossViewColumn extends Datalistviewcolumn {
    public ShowOnlyTrueValues: boolean = false;
    constructor(header?: string, property?: string, ShowOnlyTrueValues? : boolean) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (ShowOnlyTrueValues != null)
            this.ShowOnlyTrueValues = ShowOnlyTrueValues;
    }

    public override Render(item: any): string {
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        if (this.MaxLength != Number.MAX_VALUE) {
            return encodeHtml(item[this.Property].substring(0, this.MaxLength) + "...");

        } 
        else {
            let result = item[this.Property];
            if(this.ShowOnlyTrueValues){
                if(result == true){
                    return '<p style="color: green;"><b>&#x2713;</b></p>';
                }
            }
            else{
                return(result == true ? '<p class="select-item"><b>&#x2713;</b></p>' : '<p style="color: red;"><b>&#x2715;</b></p>' );
            }
        }
        return "";
    }
}

export class BooleanValuesViewColumn extends Datalistviewcolumn {
    public TrueValue: string = "true";
    public FalseValue: string = "false";
    constructor(header?: string, property?: string, trueValue?: string, falseValue?: string) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (trueValue != null)
            this.TrueValue = trueValue;
        if (falseValue != null)
            this.FalseValue = falseValue;
    }

    public override Render(item: any): string {
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }

        if (this.MaxLength != Number.MAX_VALUE) {
            return encodeHtml(item[this.Property].substring(0, this.MaxLength) + "...");

        } 
        else {
            let result = item[this.Property];
            if(result == true){
                return '<p>' + encodeHtml(this.TrueValue) + '</p>';
            }
            else{
                return '<p>' + encodeHtml(this.FalseValue) + '</p>';
            }
        }
        return "";
    }
}

export class IconViewColumn extends Datalistviewcolumn {
    public color: string = '#000000';
    public override: boolean = false;
    constructor(header?: string, property?: string, color?: string, override: boolean = false) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (color != null)
            this.color = color;
        if (override != null)
            this.override = override;

        this.IsIcon = true;
    }

    public override Render(item: any): string {
        const color = encodeHtml(this.override ? this.color : item[this.color]);
        const icon = encodeHtml(this.override ? this.Property : item[this.Property]);
        return '<i style="color:#' + color + '; font-size: 1.5em; margin-top:5px; width:100%; text-align:center" class="Icon fa fa-' + icon + '"></i>';
    }
}

export interface MultiIconDefinition {
    icon: string;
    property: string;
    activeColor: string;
    inactiveColor: string;
    activeTitle?: string;
    inactiveTitle?: string;
    condition: (value: any) => boolean;
}

export class MultiIconViewColumn extends Datalistviewcolumn {
    public icons: MultiIconDefinition[] = [];

    constructor(header?: string, icons?: MultiIconDefinition[]) {
        super(header);
        this.RendersHtml = true;

        if (header != null)
            this.Header = header;
        if (icons != null)
            this.icons = icons;

        this.IsIcon = true;
    }

    public override Render(item: any): string {
        let icons = this.icons.map(def => {
            let active = def.condition(item[def.property]);
            let color = encodeHtml(active ? def.activeColor : def.inactiveColor);
            let title = encodeHtml(active ? (def.activeTitle ?? '') : (def.inactiveTitle ?? ''));
            return '<i style="color:#' + color + '; font-size: 1.5em; width:auto;" class="fa fa-' + encodeHtml(def.icon) + '" title="' + title + '"></i>';
        }).join('');
        return '<div style="display:flex; align-items:center; gap:0.4em; white-space:nowrap;">' + icons + '</div>';
    }
}


export class CurrencyViewColumn extends Datalistviewcolumn {
    public orgService?: OrganizationsService;
    constructor(header?: string, property?: string, organizationService?: OrganizationsService) {
        super(header);

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (organizationService != null)
            this.orgService = organizationService;
    }

    public override Render(item: any): string {
        if (item[this.Property] == null || item[this.Property] == undefined){
            return '';
        }
        
        if (item[this.Property] != 0 && !item[this.Property].toString().includes(this.orgService?.OrgCurrencySymbol) && this.orgService?.OrgCurrencySymbol != undefined)
        {
            return this.orgService?.OrgCurrencySymbol + parseFloat(item[this.Property]).toFixed(2);
        }
        else
        {
            return parseFloat(item[this.Property]).toFixed(2);
        }

    }
}

export class DeviceIconcolumn extends Datalistviewcolumn {
    constructor(header?: string) {
        super(header);
        this.RendersHtml = true;
    }

    public override Render(item: any): string {
        return '<img style="vertical-align: middle; height: 1.6em;" src="' + encodeHtml(Deviceicons.GenerateIconName(item, false)) + '"/>';
    }
}

export class DataListFilterColumn extends Datalistviewcolumn {
    constructor(header?: string, property?: string, enableFilter: boolean = false, filterColumn?:string) {
        super();

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (enableFilter != false)
            this.EnableFilter = enableFilter;
        if (filterColumn != null)
            this.FilterColumn = filterColumn;
    }
}

export class DatalistRawImageColumn extends Datalistviewcolumn {
    constructor(header?: string, property?: string) {
        super(header, property);
        this.RendersHtml = true;
    }

    public override Render(item: any): string {
        if([".mp4", ".m4v", '.webm'].includes(item.Extension)) return "<i class=\"fa fa-film\" style=\"font-size:2.5em;\">";
        return '<img style="vertical-align: middle; height:40px; width:40px" src="data:image/' + encodeHtml(item.Extension) + ';base64,' + encodeHtml(item[this.Property]) + '"/>'
    }

    private getImageTag(imageBase64: any): string {
        let extension: string = '';
        const decodedString = window.atob(imageBase64);
        const lowerCase = decodedString.toLocaleLowerCase();
        if (lowerCase.indexOf("png") !== -1) extension = "png";
        else if (lowerCase.indexOf("svg") !== -1) extension = "svg+xml";
        else if (lowerCase.indexOf("jpg") !== -1 || lowerCase.indexOf("jpeg") !== -1) extension = "jpg";
        return extension;

    }

}

export class ColorDisplaycolumn extends Datalistviewcolumn {
    public mediaService : MediaService | undefined;
    constructor(header?: string, property?: string, width?: string, media?: string, mediaService?: MediaService) {
        super();
        this.RendersHtml = true;

        this.mediaService = mediaService;

        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if (width != null)
            this.Width = width;
        if (media != null){
            this.MediaId = media;
        }
    }

    public override Render(item: any): string {
        var colorDiv = '<div style="background-color:#' + encodeHtml(item[this.Property].replace("#","")) + '; width:5em; vertical-align: middle; color:white; text-align:center; height: 1.6em;">'
        if(this.MediaId != "" && item[this.MediaId] != null)
            colorDiv = colorDiv + '<img style="height:1.6em; width:1.6em;" src="' + encodeHtml(this.mediaService != null ? this.mediaService!.GetMediaUrl(item[this.MediaId]) : "") + '"/>'
        colorDiv = colorDiv + '</div>'
        return colorDiv;
    }
}

export class Linkcolumn extends Datalistviewcolumn {
    public LinkText: string | undefined;
    public LinkIcon: string | undefined;
    public Link: string | undefined;
    public ConditionalProperty: string | undefined;
    public ConditionalValue: string | undefined;
    constructor(link?: string, property?: string, linkText: string | null = null, linkIcon: string | null = "far fa-external-link", conditionalProperty?: string, conditionalValue?: string) {
        super();
        this.RendersHtml = true;

        if (property != null)
            this.Property = property;
        if(linkText != null)
            this.LinkText = linkText;
        if (link != null)
            this.Link = link;
        if (linkIcon != null)
            this.LinkIcon = linkIcon;
        if (conditionalProperty != null)
            this.ConditionalProperty = conditionalProperty;
        if (conditionalValue != null)
            this.ConditionalValue = conditionalValue;
    }

    public override Render(item: any): string {
        if(this.ConditionalProperty != undefined && this.ConditionalValue != undefined 
            && item[this.ConditionalProperty] != this.ConditionalValue) {
                return '';
            }
            
        var renderedLink = encodeHtml(this.Link?.replace('{0}', item[this.Property]));

        var linkContent = "";
        if (this.LinkIcon != undefined)
            linkContent = '<i class="'+encodeHtml(this.LinkIcon)+'"></i>'
        if (this.LinkText != undefined)
            linkContent += ' ' + encodeHtml(this.LinkText);
        // "allow-events" ensures the link remains clickable even if parent row/cell styles disable pointer events.
        return '<a class="allow-events" target="_blank" rel="noopener noreferrer" href="'+renderedLink+'">'+linkContent+'</a>';
    }
}

export class PercentagesDisplaycolumn extends Datalistviewcolumn {
    public colorDivs: string  = "";
    public cService;
    constructor(header?: string, property?: string, colorService?: ColorService) {
        super();
        this.RendersHtml = true;
        if (header != null)
            this.Header = header;
        if (property != null)
            this.Property = property;
        if(colorService != null){
            this.cService = colorService;
        }
    }

    public override Render(item: any): string {
        this.colorDivs = '<div style="width: 100%;">'
        var items = item[this.Property];
        items.forEach((element: any, index: any) => {
            if(index != (items.length-1))
                element.displayText = element.ThresholdPercent + '% - ' + (items[index+1].ThresholdPercent-1) + '%';
            if(index == (items.length-1))
                element.displayText = element.ThresholdPercent + '% - 100%';
                element.TextClass = this.cService?.GetVisibleTextClassFor(element.Color)

            this.colorDivs = this.colorDivs + '<div class="' + encodeHtml(element.TextClass)+ '" style="float:left; background-color:#' + encodeHtml(element.Color.replace("#","")) + '; width:7em; margin-right: 10px; vertical-align: middle; border: 1px solid black; color:white; text-align:center; height: 1.6em; border-radius:5px;">' + encodeHtml(element.displayText) + '</div>'
        });
        this.colorDivs = this.colorDivs + '</div>'
        return this.colorDivs;
    }
}

export class DatalistviewPercentColumn extends Datalistviewcolumn {
    public DividendProperty: string = ""; //the total number
    public DivisorProperty: string = ""; //the smaller number to calculat % of Dividend
    constructor(header?: string, dividendProperty?: string, divisorProperty?: string) {
        super(header);
        if (dividendProperty != null)
            this.DividendProperty = dividendProperty;
        if (divisorProperty != null)
            this.DivisorProperty = divisorProperty;
    }

    public override Render(item: any): string {
        let dividend = item[this.DividendProperty];
        let divisor = item[this.DivisorProperty];
        if (dividend == 0) {
            return "";
        }
        try {
            let percent = Math.round((divisor / dividend) * 100);
            if (percent > 100) {percent = 100;}
            if (percent < 0) {percent = 0;}
            return percent + "%";
        }
        catch (ex) {
            return "-";
        }

    }
}

export class DatalastviewTextAndConditionalSuffixColumn extends Datalistviewcolumn {
    public Suffix: string = "";
    public ConditionalProperty: string = "";
    public ConditionalValue: any = "";
    constructor(header?: string, property?: string, suffix?: string, conditionalProperty?: string, conditionalValue?: any){
        super(header, property);
        this.Suffix = suffix ?? "";
        this.ConditionalProperty = conditionalProperty ?? "";
        this.ConditionalValue = conditionalValue;
    }

    public override Render(item: any): string {
        var result = super.Render(item);
        if(this.Suffix != "") {
            if(this.ConditionalProperty == "" || item[this.ConditionalProperty] == this.ConditionalValue) {
                result += " " + this.Suffix;
            }
        }

        return result;
    }
}

